import Hero from "@/components/sections/Hero";
import ProofBar from "@/components/sections/ProofBar";
import PersonaPicker from "@/components/sections/PersonaPicker";
import Manifesto from "@/components/sections/Manifesto";
import WhatWeSolve from "@/components/sections/WhatWeSolve";
import Platform from "@/components/sections/Platform";
import IntelligenceOverlay from "@/components/sections/IntelligenceOverlay";
import Marquee from "@/components/sections/Marquee";
import RiskEstimator from "@/components/sections/RiskEstimator";
import PilotMetrics from "@/components/sections/PilotMetrics";
import Regulation from "@/components/sections/Regulation";
import InsightsPreview from "@/components/sections/InsightsPreview";
import CTA from "@/components/sections/CTA";

export default function Home() {
    return (
        <div data-testid="page-home">
            <Hero />
            <ProofBar />
            <PersonaPicker />
            <Manifesto />
            <IntelligenceOverlay />
            <WhatWeSolve />
            <Marquee />
            <Platform />
            <RiskEstimator />
            <PilotMetrics />
            <Regulation />
            <InsightsPreview />
            <CTA />
        </div>
    );
}
